import React from "react";
import ImageIcons from 'jd-library/ImageIcons';
import style from './no-result-found.scss';
import NoRecord from 'jd-library/NoRecord';

const NoResultFound = (props) => {
    return (
        <div
            className={style['no-result-container']}
        >
            <div className={`${style['no-result-sec']} ${style[props.manageTaxes ? 'manage-taxes-result' : '']}`}>
                <NoRecord>
                    <NoRecord.Img src={ImageIcons.NO_SEARCH} />
                    <NoRecord.SubTitle>{props.notFoundText && !props.dontShowText?props.notFoundText:props.dontShowText?'':'No Results Found'}</NoRecord.SubTitle>
                </NoRecord>
                {props.customHTML ? (
                    <div className='custom-html-container'>
                        {props.customHTML}
                    </div>
                ) : null}
            </div>
        </div>
    )
}

export default NoResultFound;